import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { AssetService } from '../../service/asset.service';
import { AssetUIMessages } from '../model/asset-ui.messages';
import { SiteModel } from '../model/site.mode';

@Component({
  selector: 'site-dropdown',
  templateUrl:
    './console/app-js/modules/asset/components/sites-dropdown/sites-dropdown.component.html'
})
export class SitesDropdownComponent implements OnInit, OnChanges {
  @ViewChild('dropdown', { static: true }) public dropdown: ComboBoxComponent;
  @Input('customerId') protected customerId: string;
  @Input('model') model: any;
  @Input('siteId') siteId: any;
  @Output('modelChange') modelChange = new EventEmitter<any>();
  private sites: Array<SiteModel>;
  protected data: Array<SiteModel>;
  protected filterData: Array<SiteModel>;
  protected filterValue: string;
  protected loading: any;
  protected progressRef: NgProgressRef;
  constructor(
    private assetService: AssetService,
    protected progressService: NgProgress
  ) {
    this.sites = [];
    this.data = [];
    this.progressRef = this.progressService.ref();
  }

  ngOnInit(): void {
    this.progressRef.start();
    this.loading = true;
    this.sites = [];
    this.data = [];
    if (this.siteId && this.customerId) {
      this.getSitesWithId();
    } else {
      this.model = '';
      this.loading = false;
      this.progressRef.complete();
    }
  }

  getSitesWithId() {
    const params = {
      siteId: this.siteId
    };
    this.assetService.getSites(this.customerId, params).subscribe(
      (result: Array<any>) => {
        if (result) {
          this.sites = result;
          this.data = result;

          if (this.siteId != null) {
            this.model = result[0];
          }
        }
        this.loading = false;
        this.progressRef.complete();
      },
      error => {
        console.error(error);
        console.error(AssetUIMessages.LOAD_SITES_ERROR);
      }
    );
  }

  getSites() {
    if (this.customerId && (this.filterValue && this.filterValue.length >= 3)) {
      const params = {
        filterValue: this.filterValue
      };
      this.assetService.getSites(this.customerId, params).subscribe(
        (result: Array<any>) => {
          if (result && this.filterValue && this.filterValue.length > 2) {
            this.sites = result;
            this.data = result;
          } else if (
            this.filterValue &&
            this.filterValue.length > 0 &&
            this.filterValue.length <= 2
          ) {
            this.data = this.sites.filter(
              s =>
                s.name.toLowerCase().indexOf(this.filterValue.toLowerCase()) !==
                -1
            );
          } else {
            this.data = [];
            this.sites = [];
          }
          this.loading = false;
          this.progressRef.complete();
        },
        error => {
          console.error(error);
          console.error(AssetUIMessages.LOAD_SITES_ERROR);
        }
      );
    } else if (this.filterValue == undefined || this.filterValue.length == 0) {
      this.model = '';
      this.loading = false;
      this.progressRef.complete();
    }
  }

  handleFilter(value) {
    this.filterValue = value;
    if (value.length >= 3) {
      this.getSites();
    } else if (
      value.length > 0 &&
      value.length < 3 &&
      this.customerId &&
      this.sites
    ) {
      this.data = this.sites.filter(
        s => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
      );
    } else if (value.length == 0) {
      this.data = [];
      this.sites = [];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customerId && !changes.customerId.firstChange) {
      this.ngOnInit();
    } else if (changes.customerId && !changes.customerId.currentValue) {
      this.ngOnInit();
    }
  }

  /**
   * On model change event.
   */
  protected onModelChange($event): void {
    this.modelChange.emit($event ? $event : null);
  }
}
